import { TaskCategory } from '../types';

/**
 * タスクカテゴリーの定数定義
 * 結婚式準備に特化したカテゴリー一覧
 */
export const TASK_CATEGORIES: TaskCategory[] = [
  '情報収集・計画',
  '式場・会場',
  '衣装・美容',
  '招待状・ペーパーアイテム',
  '料理・ケーキ',
  '装花・演出',
  '写真・映像',
  '音楽・BGM',
  '引き出物・プチギフト',
  '交通・宿泊',
  '法的手続き・事務',
  'その他'
];

// 後方互換性のためのエイリアス（段階的移行用）
export const categories = TASK_CATEGORIES; 